<template>
	<van-tabbar v-if="show" v-model="active" active-color="#7e5678" inactive-color="#979799" z-index="999">
		<van-tabbar-item v-for="(item,index) in tabs" :key="item.name" :to="item.path">
			<span>{{ $t(item.label) }}</span>
			<template #icon="props">
				<img :src="props.active ? item.iconActive : item.icon" :alt="$t(item.label)" class="imgBox" :class="{'img':index==2}"/>
			</template>
		</van-tabbar-item>
	</van-tabbar>
</template>

<script>
	export default {
		data() {
			return {
				active: 0,
				show: false,
				tabs: [{
						name: 'home',
						path: '/Home',
						label: 'foorter.index',
						icon: '/img/footer/icon1.jpg',
						iconActive: '/img/footer/icon01.jpg'
					},
					{
						name: 'choose',
						path: '/Choose',
						label: 'foorter.subscribe',
						icon: '/img/footer/icon2.jpg',
						iconActive: '/img/footer/icon02.jpg'
					},
					{
						name: 'Lottery',
						path: '/Lottery',
						icon: '/img/footer/icon.png',
						iconActive: '/img/footer/icon.png'
					},
					{
						name: 'video',
						path: '/video',
						label: 'foorter.video',
						icon: '/img/footer/icon4.jpg',
						iconActive: '/img/footer/icon04.jpg'
					},
					{
						name: 'mine',
						path: '/Mine',
						label: 'foorter.my',
						icon: '/img/footer/icon5.jpg',
						iconActive: '/img/footer/icon05.jpg'
					}
				]
			};
		},
		watch: {
			$route(to) {
				this.updateTabbar(to.name);
			}
		},
		created() {
			this.updateTabbar(this.$route.name);
		},
		methods: {
			updateTabbar(routeName) {
				const index = this.tabs.findIndex(tab => tab.name === routeName);
				this.active = index;
				this.show = index !== -1;
			}
		},
	};
</script>

<style lang="less" scoped>
	.van-tabbar {
		height: 130px;
	}

	.imgBox {
		height: 60px;
		border-radius: 50px;
	}
	.img{
		height: 120px;
		border-radius: 100px;
		position: relative;
		top:-10px
	}

	.van-tabbar-item {
		font-size: 26px;
	}

	[class*="van-hairline"]::after {
		border: none !important;
	}
</style>